import React, { useState } from 'react'
import { Button, Col, Input, Row } from 'reactstrap'

const FiltroEmpleados = (props) => {

    const { setCentroId, setDepartamentoId, setHorarioId } = props;

    
    const handleOrder = () =>{
      if(props.order==="asc") props.setOrder("desc")
      else props.setOrder("asc")
    }


    // Filtros en el estado del modal
    const [centroId, setCentroIdFiltro] = useState('');
    const [departamentoId, setDepartamentoIdFiltro] = useState('');
    const [horarioId, setHorarioIdFiltro] = useState('');
    const handleClear = () => {
    

        // Actualizamos los filtros en el estado padre
        setCentroId(null);
        setDepartamentoId(null);
        setHorarioId(null);
        setCentroIdFiltro('');
        setDepartamentoIdFiltro('');
        setHorarioIdFiltro('');
   
      };

    return (
        <>
            <tr>
                <th>
                    <Row>
                        <Col>
                            Orden:
                            <Button onClick={handleOrder} size='sm'><span className={props.order==="asc"?"text-red":""}>Asc</span>/<span className={props.order==="desc"?"text-red":""}>Desc</span></Button> 
                        </Col>
                        <Col>
                            Filtro:
                        </Col>
                    </Row>
                </th>
                <th>
                    <Input type="select" id="select-departamento" value={departamentoId}
                        onChange={(e) => setDepartamentoIdFiltro(e.target.value) & setDepartamentoId(e.target.value) }>
                        <option value="">Todos</option>
                        {props.departamentos.map(departamento => (
                            <option key={departamento.id} value={departamento.id}>{departamento.nombre}</option>
                        ))}
                    </Input>
                </th>
                <th>
                    <Input type="select" id="select-centro" value={centroId}
                        onChange={(e) => setCentroIdFiltro(e.target.value) & setCentroId(e.target.value)} >
                        <option value="">Todos</option>
                        {props.centros.map(centro => (
                            <option key={centro.id} value={centro.id}>{centro.nombre}</option>
                        ))}
                    </Input>
                </th>
                <th>
                    <Input type="select" id="select-horario" value={horarioId}
                        onChange={(e) => setHorarioIdFiltro(e.target.value) & setHorarioId(e.target.value)}>
                        <option value="">Todos</option>
                        {props.horarios.map(horario => (
                            <option key={horario.id} value={horario.id}>{horario.titulo}</option>
                        ))}
                    </Input>
                </th>
                <th><Button color='secondary' onClick={handleClear}>Limpiar</Button></th>
            </tr>
        </>
    )
}

export default FiltroEmpleados